import { render, staticRenderFns } from "./goldSight.vue?vue&type=template&id=2767cb4f&scoped=true&"
import script from "./goldSight.vue?vue&type=script&lang=js&"
export * from "./goldSight.vue?vue&type=script&lang=js&"
import style0 from "./goldSight.vue?vue&type=style&index=0&id=2767cb4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2767cb4f",
  null
  
)

export default component.exports